import { ReactNode } from "react";
import { useUserPermissions } from "@/hooks";
import WorkspacePermissionError from "./WorkspacePermission.error";
import { FeedbackProvider } from "@/infrastructure/services/feedback";

interface WorkspacePermissionGuardProps {
  children: ReactNode;
  requiredPermissions: string[];
  checkMode?: "all" | "any";
}

export function WorkspacePermissionGuard({ children, requiredPermissions, checkMode = "any" }: Readonly<WorkspacePermissionGuardProps>) {
  const { hasAnyPermission, hasAllPermissions } = useUserPermissions();

  if (checkMode === "all" && !hasAllPermissions(requiredPermissions)) {
    return <WorkspacePermissionError />;
  }

  if (checkMode === "any" && !hasAnyPermission(requiredPermissions)) {
    return <WorkspacePermissionError />;
  }

  return (
    <FeedbackProvider>
      {children}
    </FeedbackProvider>
  );
}
